enum Guard {
    PRACTITIONER = 'practitioner',
    PATIENT = 'patient'
}

export default Guard;
